import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import YearCombo from '../common/YearCombo';
import ConsultationListTable from './ConsultationListTable';
import { getBaseName } from '../common/Utils';
import { replacedoamin } from '../common/Utils';


class ConsultationListPanel extends Component {
    constructor(props) {
        super(props);

        const { history } = this.props;
        
        if ( typeof(history.location.state) === 'undefined' ) {
            history.replace(history.location.path,{pageNo:0});
        }

        this.state = {
            query: {
                lang: props.match.params.lang,
                category: props.category,                
                year: "all",
                pageNo: history.location.state['pageNo'],
                pageSize: 20,
                isLoading: true,
                errors: null,
                items: null,
                total: -1
            }
        };
    }

    mergeQuery(updates) {
        let state = this.state;
        let mergedQuery = Object.assign({},state.query,updates);
        state.query = mergedQuery;
        return state;
    }

    async refreshTable() {
        const apiUrl = `${getBaseName()}/api/consultation/search`;
        const { query } = this.state;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(query)
        }


        let updates = {};
        try {            
            const response = await fetch(apiUrl,options);
            window.scrollTo(0, 0);
            if (response.status === 200) {
                const result = await response.json();

                //console.log(result);

                updates = {
                    items: result.items,
                    total: result.total,
                    errors: null                    
                };
            } else {

            }
        } catch (error) {
            //console.log(error);
            updates = {
                errors: error
            }
        } finally {
            updates['isLoading'] = false;
            const state = this.mergeQuery(updates);
            this.setState(state);
        }

    }

    componentDidMount() {

        setTimeout(() => {this.refreshTable();},1500);

        if (typeof window.writeMenu === "function") { 
            window.writeMenu();
        }

    }

    handleYearChange(e) {
        e.preventDefault();
        const updates = { year: e.target.value, pageNo: 0, isLoading: true };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handlePageChange(data) {
        const updates = { pageNo: data.selected, isLoading: true };

        const { history } = this.props;
        history.replace(history.location.path,{pageNo:data.selected});

        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }
    
    render() {
        const { t } = this.props;
        const { query } = this.state;
        const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;
        const gaScript = `
            var _gaq = _gaq || []; 
            _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
            _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
            _gaq.push(['_trackPageview']); 
            
            (function () { 
            var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
            })();
        `;

        const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        const ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;
        //let category = this.props.category;
        //category = (category === undefined)?"all":category;

        return (
            <div style={{display:query.isLoading?"none":"block"}}>
                <Helmet>
                    <title>{t("consultation.content.title")} | {t('common:sfc')}</title>
                    <script>{gaScript}</script>
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                    <script>{ga4Script}</script>
                </Helmet>

                <div className="headline">
                    {t("consultation.content.title")}
                </div>
                <div dangerouslySetInnerHTML={{ 
                    __html: t("consultation.content.description-1") + replacedoamin(t("consultation.content.description-2"))+ t("consultation.content.description-3")
                }}></div>
                <br/>
                <div className="date-filter">
                    <YearCombo
                        startYear={1989}
                        year={query.year}
                        handleYearChange={this.handleYearChange.bind(this)}/>
                </div>
                <ConsultationListTable 
                    category={query.category} items={query.items} 
                    pageNo={query.pageNo} pageSize={query.pageSize} total={query.total}
                    handlePageChange={this.handlePageChange.bind(this)}/>
            </div>
        );
    }}

export default withRouter(withTranslation()(ConsultationListPanel));